export default __webpack_public_path__ + "static/media/Sume_RicardoBusey.f698e097.png";